import React from 'react';
import { faqs } from '../../mock/content';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';
import Reveal from './Reveal';

const FAQ = () => {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <p className="text-brand-blue text-[12px] font-bold tracking-[0.16em] uppercase mb-4">
            FAQ
          </p>
          <h2 className="text-navy font-black tracking-[-0.01em] leading-[1.12] text-[32px] sm:text-[40px] md:text-[46px]">
            Frequently asked questions
          </h2>
          <p className="mt-6 text-body-muted text-[16px] leading-[1.7]">
            Straight answers to the questions publishers ask most before they launch.
          </p>
        </div>

        <Reveal className="mt-12">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((item, i) => (
              <AccordionItem
                key={item.q}
                value={`item-${i}`}
                className="bg-white rounded-2xl shadow-mk px-6 border-none data-[state=open]:shadow-mk-lg transition-shadow duration-300"
              >
                <AccordionTrigger className="text-left text-navy font-bold text-[16px] hover:no-underline py-5">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-body-muted text-[15px] leading-[1.75] pb-5">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
};

export default FAQ;
